import getModules, { ModuleAdapted } from "navigation/config"

const useGetModuleByPath = (path?: string) => {
	const Modules = getModules()
	const location = window.location.pathname.replace(/^.+?\w+/, "")
	const currentPathname = path || location || ""
	const { isNewModule, startDate, endDate } = Modules.find(({ path }) =>
		path?.includes(currentPathname)
	) as ModuleAdapted

	return { isNewModule, startDate, endDate }
}

export default useGetModuleByPath
